export type AccountEventRow = {
  account_event_id?: string;
  account_id?: string;
  event_key?: string;
  booth_number?: string | null;
  hall?: string | null;
  is_primary_booth_exhibitor?: boolean;
};

export function sharedBoothIdsFromEvents(events: Array<{ booth_number?: string | null }>): Set<string> {
  const counts = new Map<string, number>();
  for (const row of events) {
    const booth = (row.booth_number ?? "").trim();
    if (!booth) continue;
    counts.set(booth, (counts.get(booth) ?? 0) + 1);
  }
  const shared = new Set<string>();
  for (const [booth, count] of counts) {
    if (count > 1) shared.add(booth);
  }
  return shared;
}

export function boothTooltipLabel(id: string, name: string | undefined, shared: boolean): string {
  const star = shared ? "*" : "";
  return name ? `${id} · ${name}${star} · view` : `${id} · view`;
}
